import { Smartphone, LayoutDashboard, Users, Wrench, MoveRight, MoveDown } from 'lucide-react';
import { Reveal } from '../components/Reveal';
import { Logo } from '../components/Logo';

const nodes = [
  { icon: Smartphone, label: 'DRIVERS', copy: 'Submit requests and check progress in seconds.' },
  { icon: LayoutDashboard, label: 'FLEET MANAGERS', copy: 'Live visibility of vehicle status, bookings and action needed.' },
  { relay: true, label: 'RELAY', copy: 'Relay captures, structures and routes information.' },
  { icon: Users, label: 'ACCOUNT TEAMS', copy: 'Clear priorities, less routine chasing, more time for exceptions.' },
  { icon: Wrench, label: 'SUPPLIERS', copy: 'Bookings, updates and confirmations flow through the service.' },
];

const Connector = () => (
  <>
    <MoveRight size={16} className="hidden shrink-0 text-[#0F5C4A] lg:block" aria-hidden="true" />
    <MoveDown size={16} className="mx-auto shrink-0 text-[#0F5C4A] lg:hidden" aria-hidden="true" />
  </>
);

export const ServiceLayer = () => (
  <section className="py-20 md:py-28" data-testid="service-layer-section">
    <div className="container-relay">
      <Reveal className="mx-auto max-w-2xl text-center">
        <p className="eyebrow mb-4" data-testid="service-layer-eyebrow">One connected service layer</p>
        <h2 className="text-3xl font-bold tracking-tight text-[#111111] sm:text-4xl" data-testid="service-layer-headline">
          The right information.
          <br />
          To the right people. At the right time.
        </h2>
      </Reveal>
      <div className="mt-16 flex flex-col items-stretch gap-3 lg:flex-row lg:items-center lg:gap-0">
        {nodes.map((n, i) => (
          <div key={n.label} className="contents">
            <Reveal delay={i * 0.12} className="flex-1">
              <div
                data-testid={`service-node-${n.label.toLowerCase().replace(' ', '-')}`}
                className={`flex h-full flex-col items-center rounded-xl border px-5 py-7 text-center ${
                  n.relay
                    ? 'border-[#0F5C4A] bg-[#0B1F1A] shadow-[0_20px_40px_-20px_rgba(11,31,26,0.5)]'
                    : 'border-[#E5E7EB] bg-white shadow-[0_4px_20px_rgba(16,24,40,0.04)]'
                }`}
              >
                <div
                  className={`mb-4 flex h-12 w-12 items-center justify-center rounded-full border ${
                    n.relay ? 'border-[#2E4A41] bg-[#122A23]' : 'border-[#E5E7EB] bg-[#F4F5F1]'
                  }`}
                >
                  {n.relay ? <Logo dark small /> : <n.icon size={20} strokeWidth={1.8} className="text-[#0F5C4A]" />}
                </div>
                <p className={`font-op text-[11px] font-semibold uppercase tracking-[0.2em] ${n.relay ? 'text-[#7FBFA8]' : 'text-[#0F5C4A]'}`}>
                  {n.label}
                </p>
                <p className={`mt-2.5 text-sm leading-relaxed ${n.relay ? 'text-[#C9D8D1]' : 'text-[#6B7280]'}`}>
                  {n.copy}
                </p>
              </div>
            </Reveal>
            {i < nodes.length - 1 && <Connector />}
          </div>
        ))}
      </div>
    </div>
  </section>
);
